import { render } from "./VideoThumbnail.vue?vue&type=template&id=faee590e&ts=true"
import script from "./VideoThumbnail.vue?vue&type=script&lang=ts"
export * from "./VideoThumbnail.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__